export const tableOfContents = () => {
  const postContent = document.getElementById("postContent");
  const tableOfContentsWrapper = document.getElementById("tableOfContents");
  const articleSidebar = document.getElementById("articleSidebar");
  const allHeadings = postContent?.querySelectorAll("h2, h3");

  if (
    !postContent ||
    !tableOfContentsWrapper ||
    !allHeadings ||
    allHeadings.length === 0
  )
    return;

  let headings = [];

  let h2Count = 0;
  let h3Count = 0;

  allHeadings.forEach((element) => {
    element.setAttribute(
      "id",
      element.tagName.toLowerCase() + "-" + headings.length
    );

    if (element.tagName.toLowerCase() === "h2") {
      h2Count++;
      h3Count = 0;
      headings.push({
        text: element.textContent,
        numbering: h2Count.toString(),
        id: element.getAttribute("id"),
        tag: "h2",
      });
    } else if (element.tagName.toLowerCase() === "h3") {
      h3Count++;
      headings.push({
        text: element.textContent,
        numbering: `${h2Count}.${h3Count}`,
        id: element.getAttribute("id"),
        tag: "h3",
      });
    }
  });

  const tableOfContentsList = document.createElement("ul");
  tableOfContentsList.id = "tableOfContentsList";

  headings.forEach(({ text, numbering, id, tag }) => {
    const listItem = document.createElement("li");
    if (tag === "h3") {
      listItem.style.marginLeft = "14px";
    }
    const link = document.createElement("a");

    link.href = `#${id}`;
    link.className = "table-of-contents__link";
    link.textContent = `${numbering}. ${text}`;

    listItem.appendChild(link);
    tableOfContentsList.appendChild(listItem);
  });

  const tableOfContentsContainer = document.getElementById(
    "tableOfContentsContainer"
  );
  if (!tableOfContentsContainer) return;
  tableOfContentsContainer.innerHTML = "";
  tableOfContentsContainer.appendChild(tableOfContentsList);

  function isElementPartiallyInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function updateActiveLink() {
    const scrollPosition = window.scrollY + window.innerHeight / 4;
    let activeId = null;

    for (let i = 0; i < headings.length; i++) {
      const currentHeading = document.getElementById(headings[i].id);
      const nextHeading = headings[i + 1]
        ? document.getElementById(headings[i + 1].id)
        : null;

      if (!currentHeading) continue;

      const currentTop = currentHeading.offsetTop;
      const nextTop = nextHeading ? nextHeading.offsetTop : Infinity;

      if (scrollPosition >= currentTop && scrollPosition < nextTop) {
        activeId = headings[i].id;
        break;
      }
    }

    document.querySelectorAll(".table-of-contents__link").forEach((link) => {
      link.classList.remove("isActive");
    });

    if (activeId) {
      const activeLink = document.querySelector(
        `.table-of-contents__link[href="#${activeId}"]`
      );
      if (activeLink) {
        activeLink.classList.add("isActive");

        const container = document.getElementById("tableOfContentsContainer");
        const containerTop = container.scrollTop;
        const containerHeight = container.clientHeight;
        const linkOffsetTop = activeLink.offsetTop;
        const linkHeight = activeLink.offsetHeight;

        const visibleTop = containerTop;
        const visibleBottom = containerTop + containerHeight;

        const linkTop = linkOffsetTop;
        const linkBottom = linkOffsetTop + linkHeight;

        // Jeśli link jest poza widocznym obszarem kontenera — przewiń
        if (linkTop < visibleTop) {
          container.scrollTop = linkTop;
        } else if (linkBottom > visibleBottom) {
          container.scrollTop = linkBottom - containerHeight;
        }
      }
    } else {
      const firstLink = document.querySelector(
        `.table-of-contents__link[href="#${headings[0]?.id}"]`
      );
      if (firstLink) {
        firstLink.classList.add("isActive");
      }
    }
  }

  window.addEventListener("scroll", updateActiveLink);
  updateActiveLink();

  function scrollToHeading(event) {
    event.preventDefault();

    const targetId = event.target.getAttribute("href").substring(1);
    const offset = 90;
    const targetHeading = document.getElementById(targetId);

    if (targetHeading) {
      const targetPosition =
        targetHeading.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  }

  const tableOfContentsLinks = document.querySelectorAll(
    ".table-of-contents__link"
  );
  tableOfContentsLinks.forEach((link) => {
    link.addEventListener("click", scrollToHeading);
  });

  function moveTocOnMobile() {
    const isMobile = window.innerWidth <= 991;
    const firstHeading = postContent.querySelector("h2, h3");

    if (
      isMobile &&
      firstHeading &&
      !firstHeading.previousElementSibling?.isSameNode(tableOfContentsWrapper)
    ) {
      postContent.insertBefore(tableOfContentsWrapper, firstHeading);
    } else if (
      !isMobile &&
      articleSidebar &&
      !articleSidebar.contains(tableOfContentsWrapper)
    ) {
      articleSidebar.appendChild(tableOfContentsWrapper);
    }
  }

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(moveTocOnMobile, 200);
  });

  moveTocOnMobile();
};
